import i18n from '../../../i18n/index'
export default {
  data () {
    return {
      branchCitiesDetail: [],
      search: '',
      pagination: {},
      headers: [
        {
          text: i18n.t('headers.state'),
          sortable: false,
          value: 'resource'
        },
        {
          text: i18n.t('headers.city'),
          sortable: false,
          value: 'name'
        },
        {
          text: i18n.t('headers.no-coverage'),
          sortable: false,
          value: 'coverage'
        },
        {
          text: i18n.t('headers.days-response'),
          sortable: false,
          value: 'daysresponde'
        }
      ]
    }
  },
  methods: {
    addData (item) {
      this.branchCitiesDetail = item.branchCities
    },
    showFunction () {
      this.$emit('showFunction')
    }

}
}
